import {
  Box,
  Button,
  getColor,
  Icons,
  InputArea,
  Modal,
  Tag,
  Typography,
  useToast,
} from "fds";
import "./index.scss";
import { useTranslation } from "react-i18next";
import { lazy, Suspense, useState } from "react";

import HomeTop from "./HomeTop";
import HomeBottom from "./HomeBottom";
import PowerIcon from "./PowerIcon";
import { getAdminInfoFromLocalStorage } from "../../shared/utils/auth";
import { LoginDto } from "../../types/auth";
import useAdminLoginStore from "../../redux/dispatcher/useAdminLoginStore";
import { nanoid } from "@reduxjs/toolkit";
import i18n from "../../locales/i18n";

const HomeBody = lazy(() => import("./HomeBody"));

const AdminHome: React.FC = () => {
  /** Hook  */
  const user = getAdminInfoFromLocalStorage() as string | "";
  const loginDto: LoginDto = JSON.parse(user);
  const toast = useToast();
  const { t } = useTranslation();
  const { adminAskSupport } = useAdminLoginStore();
  /** State 정리 */
  const [openRequestMarketer, toggleRequestMarketer] = useState(false); // 엽업팀에 문의하기 모달 오픈
  const [message, changeMsg] = useState("");
  /** 함수 */
  const renderEcoLiteToPrem = () => {
    return (
      <Box classes="adminHome_body" alignItems="center">
        <Tag
          backgroundColor={"#4B596B"}
          text={t("admin.home.adhoc.premium")}
          borderRadius={99}
          fontSize={11}
          classes="mg mt-42"
          style={{ marginTop: "42px" }}
          lineHeight={"12px"}
        />
        <Typography type="h1" classes="mg mt-16">
          {t("admin.home.adhoc.upgradeCollaborate")}
        </Typography>
        <Box classes="premiumCards">
          <Box direction="column" classes="premiumCard" height={331}>
            <Typography type="subtitle2" textAlign="center">
              {t("admin.home.adhoc.efficientCollaborate")}
            </Typography>
            <img
              style={{ marginTop: "13px" }}
              height={i18n.language.includes("ko") ? 267 : 246}
              src={require("../../shared/images/pages/Admin/Premium.png")}
            />
          </Box>
          <Box style={{ marginInlineStart: "11px" }} direction="column">
            <Box>
              <Box direction="column" classes="premiumCard" height={241}>
                <Typography
                  type="subtitle2"
                  textAlign="center"
                  whiteSpace="pre"
                >
                  {t("admin.home.adhoc.onePlaceTimeline")}
                </Typography>
                <img
                  style={{ marginTop: "13px" }}
                  height={i18n.language.includes("ko") ? 177 : 156}
                  width={290}
                  src={require("../../shared/images/pages/Admin/workgroup.png")}
                />
              </Box>
              <Box
                direction="column"
                classes="premiumCard"
                style={{ marginInlineStart: "11px" }}
                height={241}
              >
                <Typography
                  type="subtitle2"
                  textAlign="center"
                  whiteSpace="pre"
                >
                  {t("admin.home.adhoc.connectEssentialServices")}
                </Typography>
                <img
                  style={{ marginTop: "13px" }}
                  height={i18n.language.includes("ko") ? 177 : 156}
                  src={require("../../shared/images/pages/Admin/solution.png")}
                />
              </Box>
            </Box>
            <Box classes="morePower">
              <PowerIcon />
              <Typography
                fontSize={20}
                lineHeight={"26px"}
                fontWeight={700}
                classes="mg ml-28"
                exactColor={getColor("COLOR_TEXT_INTERACTIVE_BRAND_HOVER")}
              >
                {t("admin.home.adhoc.workbetter")}
              </Typography>
              <Typography
                // type="body2_md"
                fontSize={13}
                lineHeight={"19px"}
                fontWeight={400}
                whiteSpace="pre"
                classes="mg ml-52"
                style={{ marginInlineStart: "52px" }}
                exactColor={getColor("COLOR_TEXT_INTERACTIVE_BRAND_HOVER")}
              >
                {t("admin.home.adhoc.workbetterDesc")}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Button
          label={t("admin.home.adhoc.connectSales")}
          btnStyle="fill"
          style={{ marginBottom: "42px" }}
          classes="mg mt-32 mb-42"
          leadingIcon={<Icons variant="line" label="chat" stroke="white" />}
          onClick={() => toggleRequestMarketer(true)}
        />
      </Box>
    );
  };
  // 영업팀에 문의하기 기능
  const handleSupportAdmins = async () => {
    let resp: any = await adminAskSupport(message);
    if (resp.meta.requestStatus?.includes("fulfilled")) {
      toast.toastMsg(nanoid(), t("admin.home.adhoc.sendSuccess"), "success");
    } else {
      toast.toastMsg(nanoid(), t("admin.home.adhoc.sendFail"), "error");
    }
    changeMsg("");
    toggleRequestMarketer(false);
  };
  return (
    <Box classes="adminHome" direction="column">
      {openRequestMarketer && (
        <Modal
          title={t("admin.home.adhoc.connectSales")}
          width={540}
          open={openRequestMarketer}
          onClose={() => toggleRequestMarketer(false)}
          footer={
            <Box>
              <Button
                label={t("common.cancel")}
                btnStyle="fill"
                type="secondary"
                onClick={() => toggleRequestMarketer(false)}
              />
              <Button
                label={t("common.send")}
                btnStyle="fill"
                state={!message || message.length === 0 ? "disable" : "default"}
                onClick={handleSupportAdmins}
              />
            </Box>
          }
          body={
            <InputArea
              rows={7}
              height={240}
              maxLength={255}
              placeholder={t("admin.home.adhoc.connectSalesPlaceholder")}
              label={t("common.simpleMessage")}
              onChange={(e) => changeMsg(e.target.value)}
            />
          }
        />
      )}
      <Box height={60}>
        <Typography type="h1">{t("admin.menu.home")}</Typography>
      </Box>
      <Box direction="column" classes="mg mt-24">
        <HomeTop />
        {loginDto?.ecoSystemLicenseStats?.featureAccessType === "LITE" ? (
          renderEcoLiteToPrem()
        ) : (
          <Box direction="column">
            <Suspense fallback={null}>
              <HomeBody />
            </Suspense>
            <HomeBottom />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default AdminHome;
